module.exports = __webpack_public_path__ + "static/media/edit_square.21877d1e.svg";